import React from "react";
import Icon from "@mdi/react";
import { mdiTrashCanOutline } from "@mdi/js";
import styles from "./style.module.scss";

interface FileListProps {
  files: File[];
  onRemove: (fileId: number) => void;
}

export default function FileList({ files, onRemove }: FileListProps) {
  return (
    <>
      {files.map((file) => (
        <ul key={file.lastModified} className={styles.list}>
          <li>
            <span>{file.name}</span>
            <button type="button" onClick={() => onRemove(file.lastModified)}>
              <Icon path={mdiTrashCanOutline} />
            </button>
          </li>
        </ul>
      ))}
    </>
  );
}
